import Typography from '@mui/material/Typography';
import React from 'react';

import * as Styled from './popup-menu.style';

export type PopupMenuNoResultsProps = {
  children: React.ReactNode;
};

export const PopupMenuNoResults: React.FC<PopupMenuNoResultsProps> = ({
  children,
}) => (
  <Styled.NoResultsContainer>
    <Typography variant="body2" color="text.secondary">
      {children}
    </Typography>
  </Styled.NoResultsContainer>
);
